import api from "@/config/axios";

const URL_API = "portal-privado/home";

export default {
  getHome() {
    return api.get(URL_API);
  }
}